import { colors } from '../styles/tokens'

export function EmptyState({ title, description, action }) {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '48px 24px',
        border: `1px dashed ${colors.borderStrong}`,
        borderRadius: 8,
        background: colors.surface,
      }}
    >
      <p style={{ fontSize: 15, fontWeight: 600, color: colors.textPrimary, margin: '0 0 4px' }}>
        {title}
      </p>
      {description && (
        <p style={{ fontSize: 13, color: colors.textSecondary, margin: '0 0 16px' }}>
          {description}
        </p>
      )}
      {action}
    </div>
  )
}

export function ErrorBanner({ message }) {
  if (!message) return null
  return (
    <div
      style={{
        padding: '10px 14px',
        borderRadius: 6,
        background: colors.dangerBg,
        border: `1px solid #FCA5A5`,
        color: colors.danger,
        fontSize: 13,
        marginBottom: 16,
      }}
    >
      {message}
    </div>
  )
}

export function SuccessBanner({ message }) {
  if (!message) return null
  return (
    <div
      style={{
        padding: '10px 14px',
        borderRadius: 6,
        background: colors.successBg,
        border: '1px solid #86EFAC',
        color: colors.successText,
        fontSize: 13,
        marginBottom: 16,
      }}
    >
      {message}
    </div>
  )
}

export function SkeletonRows({ rows = 3, cols = 4 }) {
  return (
    <div style={{ padding: '4px 0' }}>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ display: 'flex', gap: 16, padding: '10px 0', borderBottom: `1px solid ${colors.border}` }}>
          {Array.from({ length: cols }).map((_, c) => (
            <div
              key={c}
              style={{
                height: 14,
                borderRadius: 4,
                background: '#EEF0F2',
                flex: c === 0 ? '0 0 120px' : 1,
                animation: 'pulse 1.4s ease-in-out infinite',
              }}
            />
          ))}
        </div>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      `}</style>
    </div>
  )
}
